import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import QuoteForm from "./QuoteForm";
import defaultImage from "../assets/default.png";
import bgPattern from "../assets/bgprod.jpg";
import { products as staticProducts } from "../data/products";

// Import your product images
import encrePrimaire from "../assets/encrePrimaire.png";
import encrePantone from "../assets/pantone.png";
import encreUV from "../assets/encreUV.png";
import plaques from "../assets/plaquesMachine.png";
import dorure from "../assets/dorure.png";
import pelliculage from "../assets/pelliculage.png";
import fildelin from "../assets/fildelin.png";
import reliureSpirale from "../assets/reliureSpirale.png";
import blanchet from "../assets/blanchet.png";
import maculante from "../assets/antimaculante.jpg";
import fildefer from "../assets/fildefer.png";
import reglette from "../assets/reglette.png";
import etirable from "../assets/etirable.png";
import aiguille from "../assets/aiguille.png";
import wash from "../assets/wash60.png";
import mouillage from "../assets/mouillage.png";
import ipa from "../assets/ipa.png";
import vernis from "../assets/vernis.png";
import gum from "../assets/gum.png";
import plateCleaner from "../assets/plateCleaner.png";

// Map filenames to imports
const imageMap = {
  "encrePrimaire.png": encrePrimaire,
  "encrePantone.png": encrePantone,
  "encreUV.png": encreUV,
  "plaques.png": plaques,
  "dorure.png": dorure,
  "pelliculage.png": pelliculage,
  "fildelin.png": fildelin,
  "reliureSpirale.png": reliureSpirale,
  "blanchet.png": blanchet,
  "maculante.png": maculante,
  "fildefer.png": fildefer,
  "reglette.png": reglette,
  "etirable.png": etirable,
  "aiguille.png": aiguille,
  "wash.png": wash,
  "mouillage.png": mouillage,
  "ipa.png": ipa,
  "vernis.png": vernis,
  "gum.png": gum,
  "plateCleaner.png": plateCleaner,
};

export default function SingleProduct() {
  const { id } = useParams();
  const [showQuoteForm, setShowQuoteForm] = useState(false);

  const product = staticProducts.find((p) => p.id === id);

  if (!product) {
    return (
      <div className="w-full bg-black min-h-screen flex items-center justify-center text-white">
        <p>Produit introuvable.</p>
      </div>
    );
  }

  // Use imageMap to resolve the image, just like in ProductsPage
  const productImage = imageMap[product.image] || defaultImage;

  return (
    <div className="w-full bg-black relative">
      <Navbar />

      {/* Background Pattern */}
      <div className="hidden lg:block absolute inset-0 z-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `linear-gradient(to bottom, black 0%, transparent 10%, transparent 90%, black 100%), url(${bgPattern})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            backgroundPosition: "top center",
          }}
        />
      </div>

      {/* Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(0,0,0,0.5) 0%,
              rgba(0,0,0,0.6) 25%,
              rgba(0,0,0,0.7) 50%,
              rgba(0,0,0,0.6) 75%,
              rgba(0,0,0,0.5) 100%
            )
          `,
        }}
      />

      <main className="relative z-10 py-24 flex flex-col gap-20">
        <div className="relative z-10 mt-10 md:mt-24 max-w-6xl px-6 lg:px-16 py-12 text-center mx-auto bg-white rounded-2xl shadow-lg">
          <p className="text-lg sm:text-xl font-semibold text-gray-600 mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
            {product.category}
          </p>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-6" style={{ fontFamily: "'Clash Display', sans-serif" }}>
            {product.title}
          </h1>

          <div className="flex justify-center mb-10">
            <img
              src={productImage}
              alt={product.title}
              className="max-h-[400px] object-contain"
            />
          </div>

          <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-8" style={{ fontFamily: "'Manrope', sans-serif" }}>
            {product.longDescription || product.description}
          </p>

          <div className="flex justify-center gap-6">
            <Link
              to="/produits"
              className="px-4 py-2 bg-transparent border-2 text-lg border-[#158DC1] text-[#158DC1] rounded-[15px] hover:bg-[#158DC1] hover:text-white transition"
            >
              Retour aux Produits
            </Link>

            <button
              className="px-6 py-2 bg-[#158DC1] text-lg text-white rounded-[15px] hover:bg-white hover:text-[#158DC1] transition"
              onClick={() => setShowQuoteForm(true)}
            >
              Demander un devis
            </button>
          </div>

          {showQuoteForm && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <QuoteForm
                productName={product.title}
                onClose={() => setShowQuoteForm(false)}
              />
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}